import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpParams } from '@angular/common/http';
import { WhatsappInstanceService } from '../../../../Services/Whatsapp/whatsapp-instance.service';
import { NotificationService } from '../../../../Services/notification.service';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-whatsapp-instance',
  standalone: true,
  imports: [CommonModule,FormsModule],
  templateUrl: './whatsapp-instance.component.html',
  styleUrl: './whatsapp-instance.component.css'
})
export class WhatsappInstanceComponent {

  /* ================= UI STATE ================= */
  isInstanceCreated = false;
  isLoading = false;

  /* ================= DATA ================= */
  instanceId: string = '';
  qrCodeUrl: string | null = null;
  // testPhoneNumber = '9326758586';
  testPhoneNumber = '8329870397';

  constructor(
    private whatsappInstanceService: WhatsappInstanceService,
    private notification: NotificationService,
    private router:Router
  ) {}

  ngOnInit(){
    const params = new HttpParams();
    this.whatsappInstanceService.getStatus(params).subscribe((res:any)=>{
      console.log("status data is",res.data);
      if(res.data.status==='active'){
        this.isInstanceCreated = true;
        this.instanceId = res.data.secret_key;
        this.refreshQr();
      }else{
        this.isInstanceCreated = false;
      }
    })
  }

  /* ================= START INSTANCE ================= */
  startInstance(): void {
    this.isLoading = true;

    this.whatsappInstanceService.createInstance().subscribe({
      next: (res: any) => {
        console.log('✅ Create Instance:', res);

        if (!res?.success) {
          this.notification.showError(res?.message || 'Failed to start', 'WhatsApp');
          this.isLoading = false;
          return;
        }

        this.instanceId = res?.data?.secret_key ?? '';
        this.isInstanceCreated = true;

        this.notification.showSuccess('Instance started successfully', 'WhatsApp');

        // backend warm-up delay
        setTimeout(() => {
          this.refreshQr();
        }, 1500);
      },
      error: (err) => {
        console.error(err);
        this.notification.showError('Instance start failed', 'WhatsApp');
        this.isLoading = false;
      }
    });
  }

  /* ================= REFRESH QR ================= */
  refreshQr(): void {
    this.isLoading = true;

    this.whatsappInstanceService.getQR(new HttpParams()).subscribe({
      next: (res: any) => {
        console.log('📷 QR Response:', res);

        if (res?.success && res?.data?.qrcode) {
          this.qrCodeUrl = res.data.qrcode;
          this.notification.showSuccess('QR Code generated', 'WhatsApp');
        } else {
          this.notification.showInfo('QR not ready yet', 'WhatsApp');
        }

        this.isLoading = false;
      },
      error: () => {
        this.notification.showError('QR fetch failed', 'WhatsApp');
        this.isLoading = false;
      }
    });
  }

  /* ================= RESTART INSTANCE ================= */
  restartInstance(): void {
    this.isLoading = true;

    this.whatsappInstanceService.restartInstance().subscribe({
      next: (res: any) => {
        console.log('🔁 Restart Response:', res);

        if (!res?.success) {
          this.notification.showError('Restart failed', 'WhatsApp');
          this.isLoading = false;
          return;
        }

        this.notification.showSuccess('Instance restarted', 'WhatsApp');
        this.qrCodeUrl = null;

        setTimeout(() => {
          this.refreshQr();
        }, 1500);
      },
      error: () => {
        this.notification.showError('Restart failed', 'WhatsApp');
        this.isLoading = false;
      }
    });
  }

  /* ================= TERMINATE INSTANCE ================= */
  terminateInstance(): void {
    this.isLoading = true;

    this.whatsappInstanceService.terminateInstance().subscribe({
      next: (res: any) => {
        console.log('🛑 Terminate Response:', res);

        if (!res?.success) {
          this.notification.showError('Termination failed', 'WhatsApp');
          this.isLoading = false;
          return;
        }

        this.isInstanceCreated = false;
        this.qrCodeUrl = null;

        this.notification.showWarning('WhatsApp instance terminated', 'WhatsApp');
        this.isLoading = false;
      },
      error: () => {
        this.notification.showError('Termination failed', 'WhatsApp');
        this.isLoading = false;
      }
    });
  }

  /* ================= SEND TEST MESSAGE ================= */
  sendTestMessage(): void {
    this.isLoading = true;

    this.whatsappInstanceService.sendWhatsappMsg({
      mobile: this.testPhoneNumber,
      message: 'Hello From Meena Silver 🚀'
    }).subscribe({
      next: (res: any) => {
        console.log('📨 Message Sent:', res);

        if (!res?.success) {
          this.notification.showError('Message failed', 'WhatsApp');
        } else {
          this.notification.showSuccess('Message sent', 'WhatsApp');
        }

        this.isLoading = false;
      },
      error: () => {
        this.notification.showError('Message failed', 'WhatsApp');
        this.isLoading = false;
      }
    });
  }

  goBack(){
    this.router.navigate(['/gst-settings']);
  }
}
